(function () {
  var PASSAGES = [
    "There is a moment when a keyboard just sounds right and you know it. Not loud, not quiet, just settled. The kind of thock that makes you stop typing for a second, hit the key again, and smile before getting back to the game.",
    "Every gamer remembers their first real setup. The desk was too small, the chair squeaked, and the keyboard glowed like a tiny arcade. Years later the gear gets better, but that feeling of pressing a key and watching the screen answer never gets old.",
    "Fast hands are built one keystroke at a time. Touch typists do not think about letters anymore; their fingers simply know where home row lives. Practice a little every day, keep your eyes on the screen, and the speed arrives on its own.",
    "A good mechanical switch actuates at the same point every single time. That consistency is the secret behind fast typing, clean inputs in ranked matches, and the quiet confidence of knowing every press will land exactly when you need it.",
    "The clock is ticking and the words keep coming. Stay loose, breathe, and let your fingers do the work. Accuracy first, speed second. One clean line of text at a time, and before you know it the sprint is over and the reward is yours.",
    "Late night, volume low, one more match before sleep. The room is dark except for the red glow of the keys. Win or lose, there is something calming about a keyboard that responds instantly, like it is just as awake as you are."
  ];

  function ensureKlaviyoJs(companyId) {
    if (
      window.klaviyo ||
      window._klOnsite ||
      document.querySelector('script[src*="static.klaviyo.com/onsite/js"]')
    ) {
      return;
    }
    var s = document.createElement("script");
    s.async = true;
    s.src =
      "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=" + companyId;
    document.head.appendChild(s);
  }

  function fallbackCopy(text, cb) {
    var ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    try {
      document.execCommand("copy");
    } catch (e) {}
    document.body.removeChild(ta);
    cb();
  }

  function initTypeSprint(section) {
    if (!section || section.dataset.typeSprintInit === "true") return;
    section.dataset.typeSprintInit = "true";

    var KLAVIYO_FORM_ID = section.dataset.klaviyoFormId || "XsCDr8";
    var KLAVIYO_COMPANY_ID = section.dataset.klaviyoCompanyId || "PeCpPN";
    var USE_KLAVIYO_COUPON = section.dataset.useKlaviyoCoupon !== "false";
    var SPRINT_SECONDS = parseInt(section.dataset.sprintSeconds, 10) || 60;
    var MIN_CORRECT_CHARS =
      parseInt(section.dataset.minCorrectChars, 10) || 25;
    var DISCOUNT_CODE = section.dataset.discountCode || "TYPE-TEST-5";
    var SHOP_URL =
      section.dataset.shopUrl ||
      "https://redragonshop.com/collections/redragon-product";

    function mountKlaviyoForm() {
      ensureKlaviyoJs(KLAVIYO_COMPANY_ID);
      setTimeout(function () {
        var holder = section.querySelector(
          ".klaviyo-form-" + KLAVIYO_FORM_ID
        );
        if (holder && holder.children.length === 0) {
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(["openForm", KLAVIYO_FORM_ID]);
        }
      }, 600);
    }

    var elPassage = section.querySelector("[data-ts-passage]");
    var elInput = section.querySelector("[data-ts-input]");
    var elWpm = section.querySelector("[data-ts-wpm]");
    var elAcc = section.querySelector("[data-ts-acc]");
    var elTime = section.querySelector("[data-ts-time]");
    var elStreak = section.querySelector("[data-ts-streak]");
    var elBar = section.querySelector("[data-ts-timebar]");
    var elHint = section.querySelector("[data-ts-hint]");
    var elFail = section.querySelector("[data-ts-fail]");
    var elResult = section.querySelector("[data-ts-result]");
    var elFWpm = section.querySelector("[data-ts-final-wpm]");
    var elFAcc = section.querySelector("[data-ts-final-acc]");
    var elFStreak = section.querySelector("[data-ts-final-streak]");
    var elForm = section.querySelector("[data-ts-emailform]");
    var elCodeW = section.querySelector("[data-ts-codewrap]");
    var elStaticCode = section.querySelector("[data-ts-staticcode]");
    var elCode = section.querySelector("[data-ts-code]");
    var elCopy = section.querySelector("[data-ts-copy]");
    var elShopCta = section.querySelector("[data-ts-shopcta]");
    var elRetry = section.querySelector("[data-ts-retry]");
    var elNewPassage = section.querySelector("[data-ts-newpassage]");

    if (!elPassage || !elInput) return;

    var passage = "";
    var spans = [];
    var idx = 0;
    var started = false;
    var finished = false;
    var startTime = 0;
    var timerId = null;
    var typed = 0;
    var correct = 0;
    var streak = 0;
    var bestStreak = 0;
    var finalWpm = 0;
    var finalAcc = 0;
    var prevVal = "";

    function pickPassage() {
      var next = PASSAGES[Math.floor(Math.random() * PASSAGES.length)];
      if (next === passage && PASSAGES.length > 1) return pickPassage();
      return next;
    }

    function renderPassage() {
      elPassage.innerHTML = "";
      spans = [];
      for (var i = 0; i < passage.length; i++) {
        var s = document.createElement("span");
        s.textContent = passage[i];
        elPassage.appendChild(s);
        spans.push(s);
      }
      if (spans[0]) spans[0].classList.add("is-cur");
    }

    function resetGame(newPassage) {
      clearInterval(timerId);
      if (newPassage || !passage) passage = pickPassage();
      started = false;
      finished = false;
      idx = 0;
      typed = 0;
      correct = 0;
      streak = 0;
      bestStreak = 0;
      elWpm.textContent = "0";
      elAcc.textContent = "100%";
      elTime.textContent = String(SPRINT_SECONDS);
      elStreak.textContent = "0";
      elBar.style.width = "100%";
      elHint.textContent =
        "Click the box above and start typing \u2014 the " +
        SPRINT_SECONDS +
        "-second timer starts on your first keystroke.";
      elResult.hidden = true;
      elFail.hidden = true;
      elCodeW.hidden = true;
      if (elStaticCode) elStaticCode.style.display = "";
      if (elForm) elForm.style.display = "";
      elInput.value = "";
      prevVal = "";
      renderPassage();
    }

    function liveStats() {
      var minutes = Math.max((Date.now() - startTime) / 60000, 1 / 60);
      var wpm = Math.round(correct / 5 / minutes);
      var acc = typed === 0 ? 100 : Math.round((correct / typed) * 100);
      elWpm.textContent = String(wpm);
      elAcc.textContent = acc + "%";
      elStreak.textContent = String(streak);
      return { wpm: wpm, acc: acc };
    }

    function tick() {
      var elapsed = (Date.now() - startTime) / 1000;
      var left = Math.max(0, Math.ceil(SPRINT_SECONDS - elapsed));
      elTime.textContent = String(left);
      elBar.style.width =
        Math.max(0, (1 - elapsed / SPRINT_SECONDS) * 100) + "%";
      liveStats();
      if (elapsed >= SPRINT_SECONDS) endSprint();
    }

    function startSprint() {
      started = true;
      startTime = Date.now();
      timerId = setInterval(tick, 250);
      elHint.textContent =
        "Sprint running \u2014 keep typing! Mistakes are highlighted in red.";
    }

    function endSprint() {
      if (finished) return;
      finished = true;
      clearInterval(timerId);
      elTime.textContent = "0";
      elBar.style.width = "0%";
      var s = liveStats();
      finalWpm = s.wpm;
      finalAcc = s.acc;
      elInput.blur();

      if (correct < MIN_CORRECT_CHARS) {
        elFail.hidden = false;
        elHint.textContent = "Sprint over \u2014 see the note below.";
        setTimeout(function () {
          elFail.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 150);
        return;
      }

      elFWpm.textContent = String(finalWpm);
      elFAcc.textContent = finalAcc + "%";
      elFStreak.textContent = String(bestStreak);
      if (elCodeW) elCodeW.hidden = true;
      if (elForm) elForm.style.display = "";
      if (elStaticCode) elStaticCode.style.display = "";
      elResult.hidden = false;
      elHint.textContent =
        "Sprint complete! Scroll down to claim your $5 OFF code.";
      setTimeout(function () {
        elResult.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 150);

      mountKlaviyoForm();
    }

    function handleKey(ch) {
      if (finished || idx >= passage.length) return;
      if (!started) startSprint();
      typed++;
      var span = spans[idx];
      span.classList.remove("is-cur");
      if (ch === passage[idx]) {
        span.classList.add("is-ok");
        correct++;
        streak++;
        if (streak > bestStreak) bestStreak = streak;
      } else {
        span.classList.add("is-bad");
        streak = 0;
      }
      idx++;
      if (idx < passage.length) {
        spans[idx].classList.add("is-cur");
        if (idx % 20 === 0)
          spans[idx].scrollIntoView({ block: "nearest" });
      } else {
        endSprint();
      }
      liveStats();
    }

    function handleBackspace() {
      if (finished || !started || idx === 0) return;
      var span = spans[idx];
      if (span) span.classList.remove("is-cur");
      idx--;
      var prev = spans[idx];
      if (prev.classList.contains("is-ok")) correct--;
      prev.classList.remove("is-ok", "is-bad");
      prev.classList.add("is-cur");
      typed = Math.max(0, typed - 1);
      streak = 0;
      liveStats();
    }

    elPassage.addEventListener("click", function () {
      elInput.focus({ preventScroll: true });
    });
    elPassage.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        elInput.focus({ preventScroll: true });
        e.preventDefault();
      }
    });

    elInput.addEventListener("input", function () {
      if (finished) {
        elInput.value = prevVal;
        return;
      }
      var v = elInput.value;
      if (v.length < prevVal.length) {
        for (var b = 0; b < prevVal.length - v.length; b++) handleBackspace();
      } else {
        for (var i = prevVal.length; i < v.length; i++) handleKey(v[i]);
      }
      prevVal = elInput.value = v.slice(0, passage.length);
    });

    elInput.addEventListener("keydown", function (e) {
      if (
        ["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End"].indexOf(
          e.key
        ) !== -1
      ) {
        e.preventDefault();
      }
    });

    elInput.addEventListener("mouseup", function () {
      var n = elInput.value.length;
      elInput.setSelectionRange(n, n);
    });

    elInput.addEventListener("paste", function (e) {
      e.preventDefault();
    });

    if (elRetry) {
      elRetry.addEventListener("click", function () {
        resetGame(false);
        elInput.focus({ preventScroll: true });
      });
    }

    if (elNewPassage) {
      elNewPassage.addEventListener("click", function () {
        resetGame(true);
        elInput.focus({ preventScroll: true });
      });
    }

    window.addEventListener("klaviyoForms", function onKlaviyo(e) {
      if (!e.detail || e.detail.formId !== KLAVIYO_FORM_ID) return;
      if (e.detail.type !== "submit") return;

      try {
        var k = window.klaviyo || window._learnq;
        if (k && k.push) {
          k.push([
            "identify",
            {
              type_sprint_wpm: finalWpm,
              type_sprint_accuracy: finalAcc,
              type_sprint_best_streak: bestStreak,
              type_sprint_date: new Date().toISOString().slice(0, 10)
            }
          ]);
        }
      } catch (err) {}

      if (USE_KLAVIYO_COUPON) {
        if (elStaticCode) elStaticCode.style.display = "none";
        setTimeout(function () {
          try {
            var m = (elForm.innerText || "").match(/Typingtest[A-Z0-9]+/i);
            if (m && elShopCta) {
              elShopCta.href =
                "https://redragonshop.com/discount/" +
                m[0] +
                "?redirect=/collections/redragon-product";
            }
          } catch (err2) {}
        }, 1200);
      } else if (elForm) {
        elForm.style.display = "none";
      }

      elCodeW.hidden = false;
      setTimeout(function () {
        if (elCodeW) {
          elCodeW.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 150);
    });

    if (elCopy) {
      elCopy.addEventListener("click", function () {
        var code = elCode ? elCode.textContent.trim() : DISCOUNT_CODE;

        function done() {
          elCopy.textContent = "\u2713 Copied";
          setTimeout(function () {
            elCopy.textContent = "Copy";
          }, 1800);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard
            .writeText(code)
            .then(done)
            .catch(function () {
              fallbackCopy(code, done);
            });
        } else {
          fallbackCopy(code, done);
        }
      });
    }

    if (elShopCta && SHOP_URL) {
      elShopCta.href = SHOP_URL;
    }

    if (elCode) {
      elCode.textContent = DISCOUNT_CODE;
    }

    if (elResult) elResult.hidden = true;
    if (elCodeW) elCodeW.hidden = true;
    if (elFail) elFail.hidden = true;

    resetGame(true);
  }

  function initAll() {
    document
      .querySelectorAll("[data-type-sprint]")
      .forEach(function (section) {
        initTypeSprint(section);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (e) {
    var section = e.target.querySelector("[data-type-sprint]");
    if (section) {
      section.dataset.typeSprintInit = "";
      initTypeSprint(section);
    }
  });
})();
